export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp@mob2x-4c7cda81faa9dd4f3374ce5e5d7771b2.png";